








import { Component, Prop } from 'vue-property-decorator';
import { UserShow } from '../middleware/UserShow';
@Component<VUSERSHOW>({
    
})
export default class VUSERSHOW extends UserShow {
    
}
